var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_1607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.75 -16C-23.75 -29.1168 -13.1168 -39.75 0 -39.75H267C280.117 -39.75 290.75 -29.1168 290.75 -16V264C290.75 277.117 280.117 287.75 267 287.75H-1.90735e-06C-13.1168 287.75 -23.75 277.117 -23.75 264V-16Z",
    stroke: "#89D5D1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#89D5D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9792 23.3333C58.1683 23.3333 62.375 27.54 62.375 32.7291V47.3541C62.375 52.5433 58.1683 56.75 52.9792 56.75H26.9583C21.7692 56.75 17.5625 52.5433 17.5625 47.3541V32.7291C17.5625 27.54 21.7692 23.3333 26.9583 23.3333H52.9792ZM29.7082 44.3333C29.7082 45.7025 28.5983 46.8125 27.2291 46.8125C25.8599 46.8125 24.7499 45.7025 24.7499 44.3333C24.7499 42.9641 25.8599 41.8541 27.2291 41.8541C28.5983 41.8541 29.7082 42.9641 29.7082 44.3333ZM27.2291 38.6666C28.5983 38.6666 29.7082 37.5567 29.7082 36.1875C29.7082 34.8183 28.5983 33.7083 27.2291 33.7083C25.8599 33.7083 24.7499 34.8183 24.7499 36.1875C24.7499 37.5567 25.8599 38.6666 27.2291 38.6666ZM37.9793 36.1875C37.9793 37.5567 36.8693 38.6666 35.5001 38.6666C34.1309 38.6666 33.0209 37.5567 33.0209 36.1875C33.0209 34.8183 34.1309 33.7083 35.5001 33.7083C36.8693 33.7083 37.9793 34.8183 37.9793 36.1875ZM44.2917 38.6666C45.6609 38.6666 46.7709 37.5567 46.7709 36.1875C46.7709 34.8183 45.6609 33.7083 44.2917 33.7083C42.9225 33.7083 41.8125 34.8183 41.8125 36.1875C41.8125 37.5567 42.9225 38.6666 44.2917 38.6666ZM54.7916 36.1875C54.7916 37.5567 53.6817 38.6666 52.3125 38.6666C50.9433 38.6666 49.8333 37.5567 49.8333 36.1875C49.8333 34.8183 50.9433 33.7083 52.3125 33.7083C53.6817 33.7083 54.7916 34.8183 54.7916 36.1875ZM52.3125 46.8125C53.6817 46.8125 54.7916 45.7025 54.7916 44.3333C54.7916 42.9641 53.6817 41.8541 52.3125 41.8541C50.9433 41.8541 49.8333 42.9641 49.8333 44.3333C49.8333 45.7025 50.9433 46.8125 52.3125 46.8125ZM35.2708 41.7291C33.8326 41.7291 32.6667 42.8951 32.6667 44.3333C32.6667 45.7716 33.8326 46.9375 35.2708 46.9375H44.5417C45.9799 46.9375 47.1458 45.7716 47.1458 44.3333C47.1458 42.8951 45.9799 41.7291 44.5417 41.7291H35.2708Z",
    fill: "#16625E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_1607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3651,
    fill: "white",
    transform: "translate(-389 -2394)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcIcon);
export default __webpack_public_path__ + "static/media/pcIcon.03bc1975aced96a75374f493662a3adc.svg";
export { ForwardRef as ReactComponent };